import styled, { css } from "styled-components";
import small_banner from "assets/images/_appointment/small_banner.png";
import { responsiveWidth } from "responsive";

export const Container = styled.div<{ active?: any }>`
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  position: fixed;
  width: 100%;
  /* position: relative; */
  top: 0;
  z-index: 99;
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  transition: all 1s;
  transition-timing-function: cubic-bezier(0.46, 0.03, 0.52, 0.96);

  @media screen and (max-width: 1024px) {
    display: block;
    height: 60px;
  }
  ${({ active }) =>
    active
      ? css`
          position: fixed;
          width: 100%;
        `
      : ""}
`;

export const Logo = styled.div`
  ${responsiveWidth}
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .hide {
    visibility: hidden;
    width: 20px;
  }
  .item-logo {
    cursor: pointer;
    width: 100px;

    @media (max-width: 567px) or (max-width: 1023px) {
      cursor: pointer;
      width: 112px;
    }
  }
  & svg {
    display: none;
    cursor: pointer;
    @media screen and (max-width: 1024px) {
      display: block;
    }
  }
`;

export const WrapperMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #e4ebe5;
  @media screen and (max-width: 1024px) {
    display: none;
  }
`;
export const MenuList = styled.div<{ active?: boolean }>`
  display: flex;
  gap: 65px;

  .subMenuLayer {
    position: fixed;
    left: 0;
    top: 60px;
    width: 100%;
    height: 230px;
    background-color: #fff;
    z-index: 10;
    transition: all 1s;
    transition-timing-function: cubic-bezier(0.46, 0.03, 0.52, 0.96);
  }

  .menu__item {
    font-family: NanumSquareOTF;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.3;
    letter-spacing: -0.05em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    @media screen and (max-width: 1024px) {
      display: none;
    }
    &-title {
      cursor: pointer;
      text-align: center;
      &:hover {
        color: #653cd5;

        font-weight: 600;

        &:before {
          content: "";
          background-color: #653cd5;
          width: 100%;
          height: 2px;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }

      &-login {
        &:hover {
          &::before {
            display: none;
          }
        }
      }
    }

    &-menu {
      min-width: 200px;
      display: none;
      flex-direction: column;
      position: absolute;
      top: 60px;
      transition: all 1s;
      transition-timing-function: cubic-bezier(0.46, 0.03, 0.52, 0.96);
      justify-items: center;
    }
  }
  .child-live {
    font-size: 16px;
    color: #653cd5;
    cursor: pointer;
    &::before {
      content: "";
      background-color: #653cd5;
      width: 100%;
      height: 2px;
      position: absolute;
      bottom: 20%;
    }
    &:hover {
      .menu__item-menu {
        display: none !important;
      }
    }
  }
  .active {
    color: #653cd5;
    > .dot {
      display: unset;
      margin: 0 4px 0 -12px;
    }
  }
  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const UserName = styled.div`
  font-family: NanumSquareOTF;
  font-size: 15px;
  font-weight: 700;
  line-height: 47px;
  letter-spacing: -0.05em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  img {
    width: 25px;
    height: 25px;
    margin-left: 11px;
    margin-top: -5px;
  }
`;

export const SubMenuList = styled.div<{
  active?: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 65px;
  width: 100vw;
  height: 230px;
  top: 60px;
  opacity: 0px;
  position: absolute;
  padding-top: 0.7%;
  padding-left: 397px;
  padding-right: 540px;
  background: #ffffff;
  align-content: flex-end;
  box-shadow: 0px 4px 12px 0px #99999940;

  ${({ active }) =>
    active
      ? css`
          top: 58px;
        `
      : ""};
`;

export const SubMenuBox = styled.div<{
  active?: boolean;
}>`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  z-index: 11;
  .subMenu {
    
    font-size: 16px;
    color: #0d0d0d;
    font-weight: 400;
    margin-bottom: 15px;
    &:last-child {
      margin-bottom: 0;
    }
    z-index: 11;
    a {
      color: #0d0d0d;
      text-align: center;
      &:hover {
      font-weight: 800;
        color: #653cd5;
      }
    }
  }
  }
`;

export const MenuListMini = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-family: NanumSquareOTF;
  font-size: 16px;
  cursor: pointer;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.05em;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  align-items: center;
  gap: 3px;

  &:hover,
  &.active {
    display: flex;
    flex-direction: row;
    color: #653cd5;
    font-weight: 800;
    > .dot {
      display: block;
      margin: 0 4px 0 -12px;
      @media screen and (max-width: 1024px) {
        display: none;
      }
    }
  }

  @media (max-width: 1024px) {
    align-items: flex-start !important;
    &:hover {
      color: #0d0d0d;
    }
    &.item__menu-sub-mobile__hidden {
      display: none !important;
    }
    .box-mobile-sub-gp {
      padding-left: 10px;
      font-weight: 400;

      display: flex;
      flex-direction: column;
      gap: 8px;
      margin: 10px 0;

      .box-mobile-sub-gp__active {
        font-weight: 400;

        color: #653cd5;
      }
    }
  }

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #653cd5;
    display: none;
  }
`;
export const MenuLogin = styled.div<{ active?: boolean }>`
  height: 60px;

  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
  letter-spacing: -1.12px;
  color: #0d0d0d;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  &:hover {
    font-weight: 800;
  }

  .menu__item {
    &:before {
      width: 0px;
    }
  }

  .value {
    font-family: NanumSquareOTF;
    font-size: 15px;
    font-weight: 700;
    line-height: 47px;
    letter-spacing: -0.05em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #653cd5;
  }

  @media screen and (max-width: 1024px) {
    display: none;
  }

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const WrapperMenuMobile = styled.div<{
  active?: boolean;
  isShow?: boolean;
}>`
  position: absolute;
  width: 100%;
  /* bottom: 0; */
  height: calc(100dvh - 60px);
  background-color: rgba(255, 255, 255, 1);
  border-top: 1px solid rgba(0, 0, 0, 0.25);
  transition: all 1s;
  transition-timing-function: cubic-bezier(0.46, 0.03, 0.52, 0.96);
  transform: translateX(100%);
  z-index: 999;

  ${({ isShow }) =>
    isShow
      ? css`
          transform: translateX(0%) !important;
        `
      : ""}
`;

export const WrapperUserMobile = styled.div`
  .linked-account {
    color: #653cd5;
    font-size: 15px;
    padding: 1% 0 5%;
    margin: 0 10%;;
    
    border-bottom: 1px solid #653cd5;
`;

export const MobileUser = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 1% 10%;
`;

export const MobileUserImg = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 50%;
`;

export const MobileUserName = styled.div`
  font-family: SpoqaHanSansNeo-Medium;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
  letter-spacing: -1.12px;
  text-align: right;
  color: #0d0d0d;
`;

export const MenuMobileBox = styled.div`
  padding: 10px calc(50% - 190px);
  overflow: hidden auto;
  height: calc(90vh - 200px);

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 567px) or (max-width: 1023px) {
    padding: 10%;
  }
`;
export const MenuMobile = styled.div<{ active?: boolean; isHide?: boolean }>`
  font-size: 18px;
  line-height: 1.19;
  letter-spacing: -1.12px;
  color: #0d0d0d;
  cursor: pointer;
  padding: 19px 0 19px;
  position: relative;
  white-space: nowrap;
  &:nth-child(5) {
    ${({ isHide }) =>
      isHide
        ? css`
            display: none;
          `
        : ""}
  }
  &.menu-active {
    letter-spacing: -0.29px;
    
    font-weight: 400;
    font-size: 18px;
    color: #653cd5;
  }
  ${(props) => {
    if (props.active) {
      return css`
        letter-spacing: -1.12px;

        font-size: 18px;
        font-weight: 400;
        position: relative;
        color: #653cd5;

        .item__menu {
          color: #0d0d0d;
        }
      `;
    }
  }}
  &:hover .item__menu {
    display: flex;
  }
  .item__menu {
    min-width: 250px;
    margin: 0px 0 -40px 10px;
    padding: 12px 0px 29px;
    /* box-shadow: 0 0 10px 0 rgb(0 0 0 / 29%); */
    background-color: rgb(0 0 0 / 0%);
    display: none;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    gap: 17px;
    /* position: absolute;
    top: 58px; */
    top: 58px; */
    z-index: 10;
    font-family: "SpoqaHanSansNeo-Light";
    font-weight: 500;
    display: flex;
    align-items: left;
    gap: 8px;
    margin-top: 10px;
    
    list-style: none;
    cursor: pointer;
    .active {
      
      font-weight: 400;
      color: #653cd5;
      .box-mobile-sub-gp {
        color: #0d0d0d;
      }
      > .dot {
        display: none;
        /* margin: 0 6px 0 -18px; */
      }
    }
    &-sub-mobile {
      display: flex;
      flex-direction: column;
      align-items: center;
      
      list-style: none;
      cursor: pointer;
      &:first-child {
        margin-top: 0;
      }
    }
  }
`;
export const MenuMobileButton = styled.div`
  position: fixed;
  bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  width: 100%;
  height: 50px;

  @media (max-width: 375px) {
    position: fixed;
  }
`;
export const ExportButton = styled.button`
  margin: 0 15px;
  width: 100%;
  height: 48px;
  background-color: #653cd5;
  font-family: NanumSquareOTF;
  font-size: 17px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: 9.45px;
  letter-spacing: -0.05em;
  text-align: center;
  color: #ffffff;
  border-radius: 8px;
  opacity: 0px;
`;

export const Menu = styled.div<{ active?: boolean }>`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.19;
  letter-spacing: -1.12px;
  color: #0d0d0d;
  cursor: pointer;
  padding: 19px 8px 19px 12px;
  position: relative;
  white-space: nowrap;
  transition: all 0.3s ease;

  ${({ active }) =>
    active &&
    css`
      color: #653cd5;
      &::before {
        content: "";
        background-color: #653cd5;
        width: 100%;
        height: 2px;
        position: absolute;
        right: 0px;
        top: 57px;
      }
    `}

  &:hover .item__menu {
    display: flex;
  }

  .item__menu {
    width: 100%;
    padding: 29px 31px;
    box-shadow: 0px 4px 12px 0px #99999940;
    background-color: #fff;
    display: none;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    gap: 17px;
    position: absolute;
    top: 58px;
    top: 58px;
    z-index: 10;
    font-family: "SpoqaHanSansNeo-Light";
    font-weight: 500;

    &-active {
      color: #653cd5;
    }
    &-sub {
      display: flex;
      align-items: center;
      gap: 4px;

      list-style: none;
      cursor: pointer;

      &:hover {
        font-weight: 600;
        > .dot {
          display: unset;
        }
      }

      .dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #653cd5;
        display: none;
      }
    }
  }
  &.menu__item-active > .menu__item-title {
    color: #653cd5;
    text-align: center;
  }
`;

export const BoxImg = styled.div`
  position: relative;
  margin-top: 60px;
  .image {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 15px;
  }
  @media (max-width: 1024px) {
    margin-top: 40px;
  }
  img {
    object-fit: cover;
    width: 100%;
    max-width: 1398px;
    height: 129px;
    @media (max-width: 1024px) {
      height: 186px;
    }
  }
  .item-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: 1398px;
    padding: 0 79px 0 58px;
    margin: 0 auto;
    @media (max-width: 1300px) {
      padding: 0 50px 0 40px;
    }
    @media (max-width: 1024px) {
      display: block;
      padding: 0;
      height: 186px;
    }
    .item-box-text {
      text-shadow: 0 0 6px #072e11;

      font-size: 25px;
      font-weight: 600;
      line-height: 1.2;
      letter-spacing: -0.5px;
      color: #fff;
      @media (max-width: 1024px) {
        margin-top: 48px;
        padding: 0 32px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      @media (max-width: 700px) {
        margin-top: 52px;
        font-size: 20px;
      }
      @media (max-width: 570px) {
        margin-top: 36px;
      }
      @media (max-width: 360px) {
        text-align: start;
      }
    }
    .item-box-button {
      @media (max-width: 1024px) {
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    button {
      width: 225px;
      background-color: #fff;
      height: 45px;
      line-height: 45px;
      text-align: center;
      border: none;

      font-size: 16px;
      font-weight: 600;
      line-height: 1.19;
      color: #0d0d0d;
    }
  }
`;

export const MiniMenuBox = styled.div<{ active?: any }>`
  height: 100px;
  /* display: none; */
  @media screen and (max-width: 1024px) {
    height: 90px;
  }
  /* ${({ active }) =>
    active
      ? css`
          display: block;
        `
      : ""} */
`;

export const SmallBanner = styled.div`
  width: 100%;
  height: 30px;
  background-image: url(${small_banner});
  background-size: cover;
  /* background-repeat: repeat-x; */
`;

export const ContentBody = styled.div`
  margin: 60px auto 0;
  padding: 0;
  @media (max-width: 360px) {
    padding: 0;
  }
`;

export const ContainerLanguage = styled.div<{ active?: any }>`
  margin-left: 50px;
  position: relative;
  height: 100%;
  &:hover {
    .box-option {
      display: block;
    }
  }
  .title-lang {
    color: #0d0d0d;

    font-size: 16px;
    font-weight: 500;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .box-option {
    position: absolute;
    top: 100px;
    left: -30px;
    width: 160px;
    padding: 20.5px 33px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.29);
    background-color: #fff;
    display: none;
    ${({ active }) =>
      active
        ? css`
            top: 60px;
          `
        : ""}
    .title-option {
      padding: 8.5px 0;
      color: #0d0d0d;

      font-size: 16px;
      font-weight: 500;
      position: relative;
      &:hover {
        font-weight: 600;
        &::before {
          content: "";
          position: absolute;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #0d0d0d;
          top: 50%;
          left: -13px;
          transform: translateY(-50%);
        }
      }

      &--active {
        font-weight: 600;
        &::before {
          content: "";
          position: absolute;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #0d0d0d;
          top: 50%;
          left: -13px;
          transform: translateY(-50%);
        }
      }
    }
  }
`;

export const ContainerRightMobile = styled.div<{ active?: any }>`
  display: none;
  @media screen and (max-width: 1024px) {
    display: flex;
    align-items: center;
  }
  .container-lang {
    margin-right: 30px;
    position: relative;
    height: 100%;
    &:hover {
      .box-option {
        display: block;
      }
    }
    .title-lang {
      color: #0d0d0d;

      font-size: 16px;
      font-weight: 500;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .box-option {
      position: absolute;
      top: 58px;
      left: -30px;
      width: 100px;
      padding: 10px 25px;
      box-shadow: 0 0 10px 0 rgb(0 0 0 / 29%);
      background-color: #fff;
      display: none;
      z-index: 2;
      ${({ active }) =>
        active
          ? css`
              top: 43px;
            `
          : ""}
      .title-option {
        padding: 5px 0;
        color: #0d0d0d;

        font-size: 16px;
        font-weight: 500;
        position: relative;
        &:hover {
          font-weight: 600;
          &::before {
            content: "";
            position: absolute;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #0d0d0d;
            top: 50%;
            left: -13px;
            transform: translateY(-50%);
          }
        }

        &--active {
          font-weight: 600;
          &::before {
            content: "";
            position: absolute;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #0d0d0d;
            top: 50%;
            left: -13px;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
`;

export const BoxLogin = styled.div`
  display: inline;
  padding: 10px;
  align-items: center;
  gap: 20px;
  width: 60px;
  height: 24px;
  gap: 0px;
  border-radius: 12px;
  border: 0.4px 0px 0px 0px;
  opacity: 0px;
  cursor: pointer;
  background: #eeeeee;
  border: 0.4px solid #bcbcbc;
  font-family: NanumSquareOTF;
  font-size: 15px;
  font-weight: 700;
  line-height: 47px;
  letter-spacing: -0.05em;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  .bonus-point {
    background-color: #653cd5;
    text-align: center;
    color: #fff;
    padding: 5px 8px;
  }
`;

export const BoxLoginMobile = styled.div`
  position: absolute;
  bottom: 130px;
  left: 0;
  right: 0;
  .bonus-point {
    background-color: #653cd5;
    text-align: center;
    color: #fff;
    padding: 5px 8px;
    max-width: 86px;
    margin: 0 auto;
  }
`;

export const Btn2 = styled.div`
  display: inline;
  cursor: pointer;
  align-items: center;
  color: #653cd5 !important;
  height: 30px;
  line-height: 32px;
  text-align: center;
  font-family: NanumSquareOTF;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: -0.05em;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  width: 100px;
  color: #ffffff;
  &#shinhansec {
    background: #f44336;
  }
  &:disabled {
    background-color: #d9d9d9 !important;
    cursor: not-allowed;
  }
`;

export const Btn2Mobile = styled.button`
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  width: calc(100% - 20px);
  margin: 10px;
  border: 1px solid #fff;
  background-color: rgb(101, 60, 213);
  border-radius: 8px;
  &:disabled {
    background-color: #d9d9d9 !important;
    cursor: not-allowed;
  }
`;
